import React, { useEffect, useState } from 'react'

import { FormWrapper } from '@/components/Forms/styles'

import { useTranslation } from 'react-i18next'

const FormRequestNewPassword = props => {
  const { userNameState, userNameHandler, requestTokenHandler } = props

  const { t } = useTranslation()

  const [labelsEmail, setLabelsEmail] = useState('')
  const [placeholdersEmail, setPlaceholdersEmail] = useState('')
  const [titlesForgotPassword, setTitlesForgotPassword] = useState('')
  const [subtitlesResetToken, setSubtitlesResetToken] = useState('')
  const [buttonsSendToken, setButtonsSendToken] = useState('')

  useEffect(() => {
    setLabelsEmail(t('labels.email'))
    setPlaceholdersEmail(t('placeholders.email'))
    setTitlesForgotPassword(t('titles.forgotPassword'))
    setSubtitlesResetToken(t('subtitles.resetToken'))
    setButtonsSendToken(t('buttons.sendToken'))
  }, [t])

  const handleSubmit = e => {
    e.preventDefault()
    requestTokenHandler()
  }

  return (
    <div id="forgot-password">
      <div className="title">
        <h1>{titlesForgotPassword}</h1>
        <h2>{subtitlesResetToken}</h2>
      </div>

      <FormWrapper onSubmit={handleSubmit}>
        <section>
          <label>{labelsEmail}</label>
          <input
            id="inp_email_request_pass"
            type="email"
            placeholder={placeholdersEmail}
            value={userNameState}
            onChange={e => userNameHandler(e.target.value)}
          />
        </section>

        <button id="btn_sendtoken" type="submit" className="btn lg blue">
          {buttonsSendToken}
        </button>
      </FormWrapper>
    </div>
  )
}

export default FormRequestNewPassword
